import React, { useCallback, useEffect, useState } from 'react';
import queueService from '../../services/queueService';

/**
 * Registrations whose automatic token could not be issued. The bill is saved; this list lets the desk issue the token. Issuing is safe to
 * repeat: the server gives one token per bill, so a second click only finds the first.
 */
export const PendingAutoTokens = ({ canIssue, refreshKey, onIssued }) => {
  const [items, setItems] = useState([]);
  const [busy, setBusy] = useState('');
  const [error, setError] = useState('');

  const load = useCallback(async () => {
    try {
      const res = await queueService.pendingAutoTokens();
      setItems(res?.success ? res.data || [] : []);
    } catch (err) { setItems([]); }    // a reminder only: a failed lookup must not break the desk
  }, []);

  useEffect(() => { load(); }, [load, refreshKey]);

  const issue = async (labNo) => {
    setBusy(labNo); setError('');
    try {
      const res = await queueService.retryAutoToken(labNo);
      if (res?.success) { await load(); onIssued?.(res.data?.ticket); } else setError(res?.message || 'Could not issue the token.');
    } catch (err) {
      setError(err?.response?.data?.message || 'Could not issue the token.');
      await load();
    } finally { setBusy(''); }
  };

  if (items.length === 0) return null;
  return (
    <div className="que-notice" role="status">
      <p><strong>{items.length} registration{items.length === 1 ? '' : 's'} without a token.</strong> The bill{items.length === 1 ? ' is' : 's are'} saved; the automatic token could not be issued.</p>
      {error && <p className="que-error" role="alert">{error}</p>}
      <ul className="que-plain-list">
        {items.map((p) => (
          <li key={p.pendingId}>
            <span>{p.labNo}{p.pName ? ` · ${p.pName}` : ''}</span>
            {canIssue && <button type="button" className="que-btn que-btn-sm que-btn-primary" disabled={busy === p.labNo} onClick={() => issue(p.labNo)}>Issue token</button>}
          </li>
        ))}
      </ul>
    </div>
  );
};

export default PendingAutoTokens;
